export const productConfig = {
  id: 'bodybase',
  landingUrl: 'https://bodybase.pro',
  paymentFailUrl: 'https://bodybase.pro/fail',
  pwa: {
    name: 'BodyBase',
    shortName: 'BodyBase',
    description: 'BodyBase',
    themeColor: '#1B3155',
    backgroundColor: '#1B3155',
    icons: [
      {
        src: '/products/bodybase/icons/android-chrome-192x192.png',
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: '/products/bodybase/icons/android-chrome-512x512.png',
        sizes: '512x512',
        type: 'image/png',
      },
      {
        src: '/products/bodybase/icons/apple-touch-icon.png',
        sizes: '180x180',
        type: 'image/png',
      },
    ],
  },
}
